import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, portfolio }) =>
    present(
      repository
        .removeProjectPortfolio(planzone, portfolio)
        .then(() => ({ planzone, portfolio }))
        .catch(() => Promise.reject({ planzone, portfolio })),
    );
}

export type { Interactor };

export { createInteractor };
